<template>
  <div class="recruit">
    <!-- 部门列表选项 -->
    <div class="recruitList">
      <div
        class="recruitOption"
        v-for="(dept, deptIndex) in departmentlist"
        :key="deptIndex"
        @click="showDept(dept, deptIndex)"
      >
        <div class="title" :class="{ active : recruitActive === deptIndex }" @click="getPosition(dept.dept.id)">
          {{dept.dept.name}}
          <img
            :src="'img/' + (recruitActive != deptIndex ? 'plus' : 'reduce') + '.png'"
            alt
          />
        </div>
        <!-- 职位列表 -->
        <ul v-show="recruitActive == deptIndex">
          <li
            v-for="(job, jobIndex) in positionlist"
            :key="jobIndex"
            :class="{ active : positionActive === jobIndex }"
            @click.stop="clickJob(job, jobIndex)"
          >{{job.joinusPosition}}</li>
        </ul>
      </div>
    </div>
    <!-- 职位展示 -->
    <div class="positionDisplay">
      <img
        :class="positionActive == -1 ? '':'dp-n'"
        src="../../../assets/images/join/recruit/join.png"
        alt
      />
      <!-- 职位部分 -->
      <div class="jobDescription">
        <!-- 职位名称 -->
        <div class="title">{{position.name}}</div>
        <div class="jobPlate">
          <div class="title">主要职责</div>
          <p>{{position.duty}}</p>
        </div>
        <div class="jobPlate">
          <div class="title">职位要求</div>
          <p>{{position.requirement}}</p>
        </div>
        <div class="jobPlate">
          <div class="title">您可以将简历及作品发送到</div>
          <a href="mailto:hr@ei-marketing.cn">hr@ei-marketing.cn</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 原始列表
      list: [],
      // 部门列表数据
      departmentlist: [],
      // 职位列表
      positionlist: [],
      // 职位展示数据
      position: {
        name: '',
        duty: '',
        requirement: ''
      },
      // 选中菜单
      recruitActive: -1,
      // 选中职位
      positionActive: -1
    }
  },
  created() {
    this.getRecruitslist()
  },
  methods: {
    // 获取部门列表
    async getRecruitslist() {
      const { data: res } = await this.$http.get('/api/item/joinus')
      if (res.content === null) {
        return this.$message.error('获取部门列表失败！')
      }
      this.list = res.content
      this.departmentlist = this.unique(res.content)
    },
    unique(arr) {
      const res = new Map()
      return arr.filter(arr => !res.has(arr.dept.id) && res.set(arr.dept.id, 1))
    },
    // 获取职位
    getPosition(id) {
      var arr = []
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].dept.id === id) {
          arr.push(this.list[i])
        }
      }
      this.positionlist = arr
    },
    showDept(dept, deptIndex) {
      this.recruitActive = deptIndex
      this.positionActive = -1
    },
    clickJob(job, jobIndex) {
      console.log(job)
      this.positionActive = jobIndex
      this.position.name = job.joinusPosition
      this.position.duty = job.joinusDuty
      this.position.requirement = job.joinusPositionstate
    }
  }
}
</script>

<style scoped>
.recruit {
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.recruit .recruitList {
  width: 100%;
  max-width: 350px;
  min-height: 530px;
  margin: 0 20px;
  background-color: #fff;
  padding: 4px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.recruitList .recruitOption {
  width: 100%;
  cursor: pointer;
}
.recruitList .recruitOption .title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  box-sizing: border-box;
  background-color: #f3f3f5;
  position: relative;
  padding: 0 20px;
}
.recruitList .recruitOption .title.active {
  color: #fff;
  background-color: rgb(235, 89, 25);
}
.recruitList .recruitOption .title img {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
}
.recruitList .recruitOption ul {
  width: 100%;
  margin-top: 10px;
}
.recruitList .recruitOption ul li {
  width: 100%;
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  box-sizing: border-box;
  cursor: pointer;
}
.recruitList .recruitOption ul li.active {
  color: rgb(235, 89, 25);
}
.recruit .positionDisplay {
  width: 100%;
  max-width: 665px;
  min-height: 530px;
  margin: 0 20px;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
}
.recruit .positionDisplay img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.jobDescription .title {
  font-weight: 600;
  font-size: 20px;
}
.jobDescription .jobPlate {
  margin: 20px 0;
  font-size: 14px;
}
.jobDescription .jobPlate .title {
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 20px;
}
.jobDescription .jobPlate p {
  white-space: pre-line;
}
</style>
